<template>
  <div class="page-wrap">
    <div class="WisdomSiteContainer">
      <Row justify="center" type="flex">
        <!-- 顶部 banner -->
        <Col span="24">
          <div class="banner-box">
            <img
              class="banner-img"
              src="../../static/img/home/core.png"
              alt="#"
            />
            <div class="banner_font">
              <div class="banner_font1">关于我们</div>
              <div class="banner_font2"></div>
              <div class="banner_font3">体验智慧工地，开启安全建设新时代</div>
            </div>
          </div>
        </Col>

        <!-- 导航栏 -->
        <Col span="24">
          <div class="nav-bar">
            <ul class="navigation">
              <li
                @click="we"
                :style="{ backgroundColor: MonitorColor, color: fontColor1 }"
              >
                关于我们
              </li>
              <li
                @click="Qualification"
                :style="{ backgroundColor: SkipVR, color: fontColor2 }"
              >
                企业资质
              </li>
            </ul>
          </div>
        </Col>

        <!-- 内容区域 -->
        <Col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
          <div class="content-box">
            <router-view></router-view>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {
      menuTheme: "light",
      MonitorColor: "#fff",
      SkipVR: "#1966ff",
      SkipQuality: "#1966ff",
      fontColor1: "#1966ff",
      fontColor2: "#fff",
      fontColor3: "#fff",
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {
    // 关于我们
    we() {
      this.$router.push({ path: "/home/AboutUs" });
      this.MonitorColor = "#fff";
      this.SkipVR = "#1966ff";
      this.fontColor1 = "#1966ff";
      this.fontColor2 = "#fff";
    },
    // 企业资质
    Qualification() {
      this.$router.push({ path: "/home/Enterprise" });
      this.MonitorColor = "#1966ff";
      this.SkipVR = "#fff";
      this.fontColor1 = "#fff";
      this.fontColor2 = "#1966ff";
    },
  },
};
</script>

<style scoped>
/* 全局重置 */
.page-wrap {
  width: 100%;
  overflow-x: hidden;
}

/* banner 区域 */
.banner-box {
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
}
.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* banner 文字 */
.banner_font {
  position: absolute;
  top: 50%;
  right: 15%;
  transform: translateY(-50%);
  z-index: 10;
}
.banner_font1 {
  font-size: 30px;
  color: #fff;
  white-space: nowrap;
}
.banner_font2 {
  width: 120px;
  height: 2px;
  background: #fff;
  margin: 15px 0;
}
.banner_font3 {
  font-size: 18px;
  color: #fff;
  white-space: nowrap;
}

/* 导航栏 */
.nav-bar {
  width: 100%;
  height: 60px;
  background: #1966ff;
}
.navigation {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}
.navigation li {
  width: 120px;
  height: 100%;
  line-height: 60px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  transition: 0.2s;
}
.navigation li:hover {
  background: #2d8cf0;
}

/* 内容区域 */
.content-box {
  padding: 20px 15px;
  width: 100%;
  box-sizing: border-box;
}

/* ==================== 手机端适配 ==================== */
@media (max-width: 992px) {
  .banner-box {
    height: 300px;
  }
  .banner_font {
    right: 10px;
    left: 10px;
    transform: none;
    top: auto;
    bottom: 20px;
    text-align: center;
    margin: 0 auto;
  }
  .banner_font1 {
    font-size: 24px;
  }
  .banner_font2 {
    margin: 10px auto;
  }
  .banner_font3 {
    font-size: 16px;
  }

  /* 导航手机端 */
  .navigation {
    justify-content: center;
  }
  .navigation li {
    width: 50%;
    max-width: 160px;
  }
}

@media (max-width: 576px) {
  .banner-box {
    height: 220px;
  }
  .banner_font1 {
    font-size: 20px;
  }
  .banner_font3 {
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AboutUs.vue